import 'photoswipe/dist/photoswipe.css';
import PropTypes from 'prop-types';
import { Gallery, Item } from 'react-photoswipe-gallery';
import { useState, useEffect } from 'react';

const MyGallery = ({ directory, filenames, isForRecentProjects }) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 640);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 640);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const [imageSizes, setImageSizes] = useState([]);

    useEffect(() => {
        const loadSizes = async () => {
            const sizes = await Promise.all(
                filenames.map((filename) => {
                    return new Promise((resolve) => {
                        const img = new Image();
                        img.src = `${directory}${filename}`;
                        img.onload = () => {
                            resolve({ width: img.naturalWidth, height: img.naturalHeight });
                        };
                    });
                })
            );
            setImageSizes(sizes);
        };

        loadSizes();
    }, [directory, filenames]);

    const gridStyle = isForRecentProjects
        ? {
            display: 'grid',
            gridTemplateColumns: isMobile
                ? 'repeat(2, 180px)'
                : 'repeat(6, 240px)',
            gridAutoRows: isMobile ? 'auto' : 'auto',
            gap: 0,
        }
        : {
            display: 'grid',
            gridTemplateColumns: isMobile
                ? 'repeat(auto-fill, 240px)'
                : 'repeat(5, 240px)',
            gridAutoRows: 'auto',
            gap: 12,
            justifyContent: 'center',
        };

    const imageWrapperStyle = {
        position: 'relative',
        width: isForRecentProjects && isMobile ? '180px' : '240px',
        aspectRatio: '4 / 3',
        overflow: 'hidden',
    };

    const imageStyle = {
        width: '100%',
        height: '100%',
        objectFit: 'cover', // Use 'contain' if you want the full image without cropping
        borderRadius: 4,
        cursor: 'pointer',
    };




    return (
        <Gallery>
            <div style={gridStyle}>
                {filenames.map((filename, index) => (
                    <Item
                        key={index}
                        original={`${directory}${filename}`}
                        thumbnail={`${directory}${filename}`}
                        width={imageSizes[index]?.width}
                        height={imageSizes[index]?.height}
                    >

                    {({ ref, open }) => (
                            <div style={imageWrapperStyle} onClick={open}>
                                <img
                                    ref={ref}
                                    src={`${directory}${filename}`}
                                    alt={`Gallery Image ${index + 1}`}
                                    style={imageStyle}
                                />
                            </div>
                        )}
                    </Item>
                ))}
            </div>
        </Gallery>
    );
};

MyGallery.propTypes = {
    directory: PropTypes.string,
    filenames: PropTypes.arrayOf(PropTypes.string).isRequired,
    isForRecentProjects: PropTypes.bool,
};

MyGallery.defaultProps = {
    directory: '',
    isForRecentProjects: false,
};

export default MyGallery;
